var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.24 0 0 229.24 0 512s229.24 512 512 512 512-229.21 512-512S794.76 0 512 0zm-.69 930.86C279.57 930.89 91.7 743.05 91.7 511.31S279.57 91.73 511.31 91.73s419.61 187.84 419.61 419.58-187.87 419.58-419.61 419.58zm-71.52-333.38L266.26 448.1l-42.08 42.09 230.55 236.46 351.93-351.94-45.24-45.24z",
    fillRule: "evenodd"
  })));
}
export default SvgCircleok;